import React  from "react"
function SqlOutput({data}){
    const headers=Object.keys(data[0]);
    return (
        <>
        <table id="dbdatatable" className="table table-striped table-hover table-bordered" 
        style={{width:"100%"}}>
            <thead>
                <tr>
                   { headers.map((h)=><th>{h}</th>)} 
                </tr>
            </thead>
            <tbody>
        {
          data.map((obj)=>{
            let values=Object.values(obj);
            return(<tr>{
                values.map((value)=>{
                    return (<td>{value}</td>)
                  })}</tr>) 
          })
        }
        </tbody> 
        </table>
        </>
    )
}
export default SqlOutput